import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@app/base/basecomponent';
import { User } from '@app/_models/user/user';
import { SetPermissions } from '@app/_store/app.actions';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss']
})
export class NoAccessComponent extends BaseComponent implements OnInit {

  public user: Observable<User>;

  constructor(
    private store: Store
  ) {
    super();
  }

  ngOnInit(): void {
    this.user = this.authService.currentUser;

    // clear permissions since the module guard doesn't execute when doing redirects
    this.store.dispatch(new SetPermissions(null));
  }

}
